import type { RequestFn } from 'api/useApiRequest';

export interface TeamLobbyingMaterialItem {
  id: number;
  title: string;
  type: string;
  publishedAt: string | null;
  createdAt: string;
}

export const fetchTeamLobbyingMaterial = (request: RequestFn, { signal }: { signal?: AbortSignal } = {}) =>
  request({
    method: 'get',
    pathname: '/api/user-generated-content/get-team-user-generated-content',
    signal,
  });
